var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompanyObjectRefSelect',{attrs:{"options":_vm.options,"mode":_vm.mode,"default-option":_vm.noTimeBreakdownOption,"object-type":"company_dimension","placeholder":"Time Dimension","external-path":"/definitions","external-query":{
    tab: 'dimensions',
  }},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }